import { toast } from "react-toastify";
import requestUtil from "../../../../helpers/requestUtil";
import { setLoading } from "../../../common/Loader/slice";
import * as Toasts from "../../../common/Toastify";
import {
  resetError,
  setCandidateLocationStatus,
  setcandidateRating,
  setCandidateSearchViewInfo,
  setError,
  setMasterData,
  updatecandidateRating,
  setUpdateQA,
  setEmployerComments,
  setEmployerCommentsHistory,
  setEmployerValidationGetCertificationList,
  setCertificationsEmployersCandidateValidation,
  setUpdateCertificationsData,
  setEmployersVerificationCommentsHistory,
  setEmpUploadedList,
  setLoadingFlagIncrement,
  setLoadingFlagDecrement,
  pageReset,
  setResetData,
  setNewCertificationsDuplicateCopy,
  setQATabDuplicateDataV2,
  setCommentHistory,
} from "./slice";
import { updateSharedSlice } from "../../../shared/sharedSlice";

export const getCandidateSearchViewDetail = ({
  url,
  candidateUniqueId,
  employerUniqueId,
}) => {
  return async (dispatch) => {
    // dispatch(setLoading(true));
    dispatch(setLoadingFlagIncrement());
    try {
      const response = await requestUtil(`${url}`, "POST", {
        candidateUniqueId,
        employerUniqueId,
      });
      dispatch(setCandidateSearchViewInfo(response));
      dispatch(setQATabDuplicateDataV2(response));
    } catch (error) {
      dispatch(setError(error.message));
    } finally {
      // dispatch(setLoading(false));
      dispatch(setLoadingFlagDecrement());
    }
  };
};

export const loadMasterData = (baseUrl, empUniqueId) => {
  return async (dispatch,getState) => {
    // dispatch(setLoading(true));
    const state = getState();
    const locationSharedList = state.shared.locationSharedList;
    let location = locationSharedList ?? [];
    try {
    dispatch(setLoadingFlagIncrement());
      const status = await requestUtil(
        `${baseUrl}/Dropdown/get-candidate-status-for-employer-status-update-dropdown`,
        "GET"
      );
      if(location?.length === 0){
         location = await requestUtil(
          `${baseUrl}/Locations/get-location-list-for-dropdown/${empUniqueId}`,
          "GET"
        );
        dispatch(updateSharedSlice({name:"locationSharedList",value:location}))
      }
      dispatch(setMasterData({ status, location }));
    } catch (error) {
      dispatch(setError(error.message));
    } finally {
      // dispatch(setLoading(false));
      dispatch(setLoadingFlagDecrement());
    }
  };
};

export const setCandidateRating = ({ url, params }) => {
  return async (dispatch) => {
    // dispatch(setLoading(true));
    dispatch(setLoadingFlagIncrement());
    try {
      const response = await requestUtil(`${url}`, "POST", { ...params });
      Toasts.success("Candidate Rating Saved Successfully.");
    } catch (error) {
      dispatch(setError(error.message));
    } finally {
      // dispatch(setLoading(false));
      dispatch(setLoadingFlagDecrement());
    }
  };
};

export const getCandidateRating = ({ url, params }) => {
  return async (dispatch) => {
    // dispatch(setLoading(true));
    dispatch(setLoadingFlagIncrement());

    try {
      const response = await requestUtil(`${url}`, "POST", { ...params });
      dispatch(setcandidateRating({ response }));
    } catch (error) {
      dispatch(setError(error.message));
    } finally {
      // dispatch(setLoading(false));
      dispatch(setLoadingFlagDecrement());
    }
  };
};

export const updateCandidateRating = ({ data }) => {
  return async (dispatch) => {
    try {
      dispatch(updatecandidateRating(data));
    } catch (error) {
      dispatch(setError(error.message));
    }
  };
};

export const updateCandidateStatus = ({ url, params }) => {
  return async (dispatch) => {
    // dispatch(setLoading(true));
    dispatch(setLoadingFlagIncrement());
    try {
      const response = await requestUtil(`${url}`, "POST", { ...params });
      Toasts.success(response.message);
      return response?.result ? true : false;
    } catch (error) {
      dispatch(setError());
      Toasts.error(error.message);
      return  false;
    } finally {
      // dispatch(setLoading(false));
      dispatch(setLoadingFlagDecrement());
    }
  };
};

export const getCandidateLocationStatus = ({ url, params }) => {
  return async (dispatch) => {
    // dispatch(setLoading(true));
    dispatch(setLoadingFlagIncrement());

    try {
      const response = await requestUtil(`${url}`, "POST", { ...params });
      dispatch(setCandidateLocationStatus(response));
      dispatch(setLoading(false));
      return response;
    } catch (error) {
      dispatch(setError(error.message));
    } finally {
      // dispatch(setLoading(false));
      dispatch(setLoadingFlagDecrement());
    }
  };
};

export const updateCandidateFavorites = ({ url, params }) => {
  return async (dispatch) => {
    // dispatch(setLoading(true));
    dispatch(setLoadingFlagIncrement());
    try {
      const response = await requestUtil(`${url}`, "POST", { ...params });
      Toasts.success(response?.message);
    } catch (error) {
      dispatch(setError(error.message));
    } finally {
      // dispatch(setLoading(false));
      dispatch(setLoadingFlagDecrement());
    }
  };
};
export function reset() {
  return async (dispatch) => {
    dispatch(resetError());
  };
}

export const updateQAData = (data) => {
  return async (dispatch) => {
    dispatch(setUpdateQA(data));
  };
};

export const getEmployerComments = ({
  url,
  candidateUniqueId,
  employerUniqueId,
}) => {
  return async (dispatch) => {
    // dispatch(setLoading(true));
    dispatch(setLoadingFlagIncrement());

    try {
      const response = await requestUtil(`${url}`, "POST", {
        candidateUniqueId,
        employerUniqueId,
      });
      dispatch(setEmployerComments(response));
    } catch (error) {
      dispatch(setError(error.message));
    } finally {
      // dispatch(setLoading(false));
      dispatch(setLoadingFlagDecrement());
    }
  };
};

export const getEmployerCommentsHistory = ({
  baseUrl,
  candidateUniqueId,
  employerUniqueId,
  employerCandidateProfileFormValueId,
}) => {
  return async (dispatch) => {
    // dispatch(setLoading(true));
    dispatch(setLoadingFlagIncrement());
    try {
      const response = await requestUtil(
        `${baseUrl}/Employers/get-employers-comment-history`,
        "POST",
        {
          candidateUniqueId,
          employerUniqueId,
          employerCandidateProfileFormValueId,
        }
      );
      dispatch(setEmployerCommentsHistory(response));
    } catch (error) {
      dispatch(setError(error.message));
    } finally {
      // dispatch(setLoading(false));
      dispatch(setLoadingFlagDecrement());
    }
  };
};

export const getCertificationsList = (
  baseUrl,
  employerUniqueId,
  candidateUniqueId
) => {
  return async (dispatch) => {
    dispatch(setLoadingFlagIncrement());
    try {
      // dispatch(setLoading(true));
      const response = await requestUtil(
        `${baseUrl}/Jobs/getcandidatescertificationsemployersvalidation/${employerUniqueId}/${candidateUniqueId}`,
        "GET"
      );
      // dispatch(setLoading(false));
      dispatch(setEmployerValidationGetCertificationList(response));
      dispatch(setNewCertificationsDuplicateCopy(response));

    } catch (error) {
      dispatch(setError(error.message));
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
  };
};

export const saveCertificationEmployerValidation = ({
  baseUrl,
  employerUniqueId,
  candidateUniqueId,
  appUserUniqueId,
  certificationsEmployersCandidatesValidationsFormDetails,
}) => {
  return async (dispatch) => {
    // dispatch(setLoading(true));
    dispatch(setLoadingFlagIncrement());

    try {
      const response = await requestUtil(
        `${baseUrl}/Jobs/savecandidatescertificationsemployersvalidation`,
        "POST",
        {
          employerUniqueId: employerUniqueId,
          candidateUniqueId: candidateUniqueId,
          appUserUniqueId: appUserUniqueId,
          certificationsEmployersCandidatesValidationsFormDetails:
            certificationsEmployersCandidatesValidationsFormDetails,
        }
      );
      dispatch(setCertificationsEmployersCandidateValidation(response));
      Toasts.success("Validation Saved Successfully");
    } catch (error) {
      dispatch(setError(error.message));
      console.log(error);
      Toasts.error("Failed to update data");
    } finally {
      // dispatch(setLoading(false));
      dispatch(setLoadingFlagDecrement());
    }
  };
};

export const updateCertificationsData = (data) => {
  return async (dispatch) => {
    dispatch(setEmployerValidationGetCertificationList(data));
  };
};

export const getEmployersVerificationCommentsHistory = ({
  baseUrl,
  candidateUniqueId,
  employerUniqueId,
  candidateCertificationEmployerValidationId,
}) => {
  return async (dispatch) => {
    // dispatch(setLoading(true));
    dispatch(setLoadingFlagIncrement());

    try {
      const response = await requestUtil(
        `${baseUrl}/Employers/get-employers-verification-comment-history`,
        "POST",
        {
          candidateUniqueId,
          employerUniqueId,
          candidateCertificationEmployerValidationId,
        }
      );
      dispatch(setEmployersVerificationCommentsHistory(response));
    } catch (error) {
      dispatch(setError(error.message));
    } finally {
      // dispatch(setLoading(false));
      dispatch(setLoadingFlagDecrement());
    }
  };
};
export const generateUploadRows = (uploadList,remainingUploads) => {
  let updateUploadList = [...uploadList];
  const docId = updateUploadList?.at(-1)?.docId < 0 ? updateUploadList?.at(-1)?.docId : 0;
  const lastUpload = {
    "uploadedFileName": "",
    "blobFileName": "",
    "docId": docId,
    "employerId": 0,
    "result": 0,
    "message": "",
    "messagesParameters": null
};
if(remainingUploads){
  for(let i = 0; i < remainingUploads; i++){
    updateUploadList.push({...lastUpload,docId:(lastUpload?.docId - (i+1))})
  }
}
  return updateUploadList;
}
export const getEmpUploadedList = ({
  url,
  employerUniqueId,
  candidateUniqueId,
}) => {
  return async (dispatch,getState) => {
    dispatch(setLoadingFlagIncrement());
    const state = getState();
    const empUploadedList = state.candidateSearchViewInfo.empUploadedList;
    try {
      const response = await requestUtil(
        `${url}/Candidates/get-employer-uploads-for-candidate`,
        "POST",
        { employerUniqueId, candidateUniqueId }
      );
      const remainingUploads = response?.uploadedDocsList?.length % 5 ? (5 - (response?.uploadedDocsList?.length % 5)) :0 ;
      // const remainingUploads =  empUploadedList?.length === 0 ? 0  :  Math.abs(response?.uploadedDocsList?.length - empUploadedList?.length) ;
      const responseUploads = generateUploadRows(response?.uploadedDocsList, remainingUploads);
      dispatch(setEmpUploadedList(responseUploads));
    } catch (error) {
      dispatch(setError(error.message));
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
  };
};

export const uploadEmpDocument = ({
  url,
  employerUniqueId,
  candidateUniqueId,
  file,
  index,
}) => {
  return async (dispatch, getState) => {
    // const { empUploadedList } = getState().candidateSearchViewInfo;
    // const newVal = JSON.parse(JSON.stringify(empUploadedList));
    dispatch(setLoadingFlagIncrement());
    try {
      const formdata = new FormData();
      formdata.append("file", file);
      const response = await requestUtil(
        `${url}/Employers/upload-employer-document?employerUniqueId=${employerUniqueId}&candidateUniqueId=${candidateUniqueId}`,
        "POST",
        formdata,
        null,
        true
      );
      //  if(response){
      //   if(response?.blobFileName && response?.docId && response?.uploadedFileName ){
      //     newVal.splice(index,1,{
      //       "blobFileName": response?.blobFileName,
      //       "docId":response?.docId,
      //       "message":response?.message,
      //       "messagesParameters":response?.messagesParameters,
      //       "result":response?.result,
      //       "uploadedFileName":response?.uploadedFileName
      //     })
      //   }
      //   dispatch(setEmpUploadedList(newVal))
      //  }
      Toasts.success(response.message);
    } catch (error) {
      dispatch(setError(error.message));
      Toasts.error(error.message);
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
  };
};

export const deleteEmpDocument = ({ url, docId }) => {
  return async (dispatch, getState) => {
    // const { empUploadedList } = getState().candidateSearchViewInfo;
    // const newVal = JSON.parse(JSON.stringify(empUploadedList));
    dispatch(setLoadingFlagIncrement());
    try {
      const response = await requestUtil(
        `${url}/Employers/delete-employer-document?candidateEmployerUploadId=${docId}`,
        "DELETE"
      );
      // const indexOfDoc = newVal?.findIndex(item => item.docId === docId)
      // newVal.splice(indexOfDoc,1,{
      //   "blobFileName": "",
      //   "docId":-1,
      //   "message":"",
      //   "messagesParameters":null,
      //   "result":0,
      //   "uploadedFileName":""
      //   })
      // dispatch(setEmpUploadedList(newVal))
      Toasts.success("Deleted Successfully");
    } catch (error) {
      dispatch(setError(error.message));
      Toasts.error(error.message);
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
  };
};

// Page Refersh function
export const clearData = () => {
  return async (dispatch) => {
    dispatch(pageReset());
  };
};

// Send Mail To candidate
export const sendMailToCandidateNoUploadCertificate = (
  url,
  candidateUniqueId,
  mailBody,
  sourceWebsite
) => {
  return async (dispatch) => {
    dispatch(setLoadingFlagIncrement());
    try {
      await requestUtil(`${url}/Employers/sendmail-to-candidate-for-noupload`, "POST", {
        candidateUniqueId,
        mailBody,
        sourceWebsite
      });
      // dispatch(setEmployerComments(response));
    } catch (error) {
      dispatch(setError(error.message));
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
  };
};

// export const downloadEmpDocument = ({url,docId}) => {
//   return async(dispatch) => {
//     dispatch(setLoading(true))
//     try {
//       const response = await requestUtil(`${url}/Employers/download-employer-document?candidateEmployerUploadId=${docId}`,"GET")
//       // dispatch(setEmpUploadedList(response))
//     } catch (error) {
//       dispatch(setError(error.message));
//     }finally {
//       dispatch(setLoading(false))
//     }
//   }
// };

export function sendEmail({ url, params }) {
  return async (dispatch) => {
    dispatch(setLoadingFlagIncrement());
    try {
      const response = await requestUtil(`${url}`, "POST", { ...params });
      Toasts.success("Email sent successfully!");
      return response;
    } catch (error) {
      Toasts.error("Email not sent!");
      return error.message;
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
  };
}

export function sendSMS({ url, params }) {
  return async (dispatch) => {
    dispatch(setLoadingFlagIncrement());
    try {
      const response = await requestUtil(`${url}`, "POST", { ...params });
      Toasts.success("Sms sent successfully!");
      return response;
    } catch (error) {
      return error.message;
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
  };
}

export function getEmailDetails({ url }) {
  return async (dispatch) => {
    dispatch(setLoadingFlagIncrement());
    try {
      const response = await requestUtil(`${url}`, "GET");
      return response;
    } catch (error) {
      return error.message;
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
  };
}

export function getSMSDetails({ url, params }) {
  return async (dispatch) => {
    dispatch(setLoadingFlagIncrement());
    try {
      const response = await requestUtil(`${url}`, "POST", { ...params });
      return response;
    } catch (error) {
      return error.message;
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
  };
}

export function sendAllEmailbtn(url) {
  return async (dispatch) => {
    dispatch(setLoadingFlagIncrement());
    try {
      const response = await fetch(url);
      return response;
    } catch (error) {
      return error.message;
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
  };
}


export function sendAllSmsbtn(url) {
  return async (dispatch) => {
    dispatch(setLoadingFlagIncrement());
    try {
      const response = await fetch(url);
      return response;
    } catch (error) {
      return error.message;
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
  };
}

export function getCallHistory(url, params) {
  return async (dispatch) => {
    dispatch(setLoadingFlagIncrement());
    try {
      const response = await requestUtil(
        `${url}/Voice/get-recordings`,
        'POST', params
      );;
      dispatch(setCommentHistory({ name: "phoneHistory", value: response }))
      return response;
    } catch (error) {
      return error.message;
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
  };
}

export const getCommentEmailSMSPhoneHistory = ({ url, name, params, method }) => {
  return async (dispatch) => {
    dispatch(setLoadingFlagIncrement());
    try {
      const result = await requestUtil(url, method, params && { ...params });
      if (result?.length) {
        dispatch(setCommentHistory({ name, value: result }))
      }
    } catch (error) {
      return error.message;
    }
    finally {
      dispatch(setLoadingFlagDecrement());
    }
  }
}


